/**
 * 海关编码 - 证书审核
 *
 * @author FJJ
 * @version 1.0
 * @copyright 2021-2021, all rights reserved. Essa.cn
 */
import React from 'react';
import CommonBreadcrumb from "@components/CommonBreadcrumb";
// import FormFormat from "@components/FormFormat/FormFormat"
import ImageHover from "../../Components/ImageHover";
import {Spin, Row, Col, Form, Radio, Input,message} from 'antd';
import {Prompt} from 'react-router-dom';
import Certificate from '../../StickerBrand/Certificate/Certificate'
import Lang from "@components/Lang/Lang";
import dayjs from "dayjs";
import {isEmpty} from '@utils/utils';
import "./Detail.less";
import CustomsDeclarationStickerAction from "../../CustomsDeclarationSticker.action";
import PageCommon from '../../../../components/PageCommon/PageCommon';
import IconChinaOrderGoods from "@components/Icon/IconDirectPo/IconChinaOrderGoods";//直达商品图标

const { TextArea } = Input;
const FormComponent = Form;
const FormItem = FormComponent.Item;
const config = require("@config/config");
class CertificateReviewList extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            isHadEdit: false, //是否编码过
            isEdit: false, // 当前是可编码状态
            item:{
                code:'PO单号'
            },
            list: [
            ],
            //字典code:sale_po_sticker_track_even_code 事件编码 (10:侵权确认,20:侵权审核,30:海关编码,40:证书设置,50:证书审核,60:无证书状态)
            eventCode:'50',
            certDict: [
                { label: Lang({id:'YouZhengShu',default:'有证书'}), value: 1 },
                { label: Lang({id:'WuZhengShu',default:'无证书'}), value: 0 },
                // { label: 'Orange', value: 'Orange', disabled: true },
            ],
            formItemLayout:{
                labelAlign: 'left',
            }
        }
        this.listener = e => {
            if(this.state.isHadEdit){
                e.preventDefault();
                e.returnValue = Lang({id:'LiKaiDangQianYeHou，SuoBianJiDeShuJuJiangBuKeHuiFu',default:'离开当前页后，所编辑的数据将不可恢复'}) // 浏览器有可能不会提示这个信息，会按照固定信息提示
            }
        }
    }
    /**
     * 查看详情
     * */
    getDetail(sId){
        this.loading(true);
        const data = {
            trackId:sId,
            eventCode:this.state.eventCode,
        }
        CustomsDeclarationStickerAction.getCertificateAuditDetail(data).then(res=>this.handleRes(res.data)).catch(err=>this.handleRes(err))
    }
    handleRes(res){
        this.loading(false);
        const {success,valid,model,models} = res;
        const list = models || [];
        list.forEach(item=>{

            if(item.hasCertificate=== 1 && item.isFurnishCertificate === 0){
                item.hasCertificate = 2;
            }


        })

        if(success&&valid){
            this.setState({
                item:model||{},
                list: list
            })
        }
    }
    loading(flag) {
        this.setState({
            loading: flag,
        });
    }

    /**
     * 行编
     *
     * */
     setCertificateType(type,inx,field){
        const {list,isHadEdit,isEdit} = this.state;
        let newList = [...list];
        newList[inx][field] = type;
        this.setState({
            list:newList,
        })
        if(!isHadEdit&&isEdit)this.setHadEdit(true);
    }

    setCertificate(data,inx,field){
        console.log(data)
        console.log(inx)
        console.log(field)

        const {list,isHadEdit,isEdit} = this.state;
        let newList = [...list];
        newList[inx][field] = data;
        this.setState({
            list:newList,
        })
        if(!isHadEdit&&isEdit)this.setHadEdit(true);

    }

    getCerId(str,pathname){
        let iId = str.length>0?str.substr(1,str.length):'';
        iId = iId?Number(iId):'';
        const isEdit = pathname.indexOf('View')>-1 ? false:true; // 查看模块不可编码
        this.setState({
            iId: iId,
            isEdit:isEdit
        })
        return iId;
    }
    /**
     * 渲染列表
     * @list 数据源
     * @isEdit 编辑类型 isEdit : true 可编辑 false 查看状态，不可编辑
     * @formItemLayout 格式
     * @certDict 证书类型
     * **/
    // 属性列表
    renderAttribute(attributeList=[]){
        let childAtt = [];
        attributeList.forEach((att,inx)=>{
            if(att.optionList&&att.optionList.length>0)childAtt.push(<Col span={inx==0?6:12} key={inx} className={'descItem'}>{att.attributeName}{att.optionList.map((item, suinx)=>(<span key={suinx}>{item.optionName}</span>))}</Col>)
        })
        return childAtt;
    }
    renderOne(item={},isEdit=false,formItemLayout,certDict,inx){
        item.disabled = isEdit?false:true;
        return(<div className={`itemLi${item.isTort==1?" itemLiTort":""}`} key={inx}>
            <div className={'pro'}>
                {item.skuPictureUrl&&<ImageHover src={item.skuPictureUrl} />}
            </div>
            <div className={'info'}>
                <div className={'top'}>
                    <p className={"black89 fw_500"}>{Lang({id: 'DingDanShiJian', default: '订单时间'})}<span>{item.poCreateTime&&dayjs(item.poCreateTime).format('YYYY-MM-DD HH:mm')}</span></p>
                    {/* 中国直达新增 isTort :1 商品侵权 */}
                    {item.isTort==1?<div className={"mt_8 mb_8"}>
                        <span className={"labelTort"}>{Lang({id: 'ChanPinYiQinQuan', default: '产品已侵权'})}</span>
                    </div>:null}
                    {/*<p>{item.skuNameRu}</p>*/}
                    <p className={'blackLink'}><a href={config.servers[config.environment].portalUrl+`/${item.goodsId}.html?skuNo=${item.skuNo}`} target={'_blank'}>{item.skuNameRu}</a></p>
                </div>
                <div className={'desc'}>
                    <Row gutter={24}>
                        <Col span={6} className={'descItem'}>{Lang({id: 'ShangPinBianMa', default: '商品编码'})}<span>{item.skuNo}</span></Col>
                        <Col span={8} className={'descItem'}>{Lang({id: 'LeiMu', default: '类目'})}<span>{item.categoryName}</span></Col>
                        <Col span={8} className={'descItem'}>{Lang({id: 'CaiZhi', default: '材质'})}<span>{item.mainMaterials}</span></Col>
                        {this.renderAttribute(item.attributeList)}
                    </Row>
                </div>
                <div className={'cerSetBox'}>
                    <Row>
                        <Col>
                            <FormItem {...formItemLayout} label={Lang({id: 'ShangPinZhengShu', default: '商品证书'})}>
                                <FormItem { ...formItemLayout}
                                          name={'hasCertificate'}
                                          noStyle
                                          rules={[{ required:true, message: Lang({id: 'ShangPinZhengShu', default: '商品证书'})}]}>
                                    {/* <Radio.Group
                                        options={certDict}
                                        optionType="button"
                                        value={item.hasCertificate}
                                        onChange={(e)=>this.onChangeField(e,inx,'hasCertificate')}
                                        disabled={item.disabled} /> */}

                                        <div className='CertificateType'>

                                        {/* <Certificate success={(data) => {
                                                console.log(data)
                                                var value = data.map(i=>{
                                                    return {
                                                        code:i.code,
                                                        saleGoodsCertificateId:i.id,
                                                    }
                                                })
                                                this.setCertificate(value,inx,'goodsCertificateList')
                                            }} selectedRows={item.goodsCertificateList}> */}
                                                <span className={`CertificateType-option ${item.hasCertificate == 1?'cur':''}`} onClick={(e) => {this.setCertificateType(1,inx,'hasCertificate')}}>{Lang({id: 'YouZhengShu', default: '有证书'})} 
                                                    <span className="ri-edit-line" style={{float:'right'}}></span>
                                                </span>
                                            {/* </Certificate> */}

                                            <span className={`CertificateType-option ${item.hasCertificate == 0?'cur':''}`} onClick={(e) => {this.setCertificateType(0,inx,'hasCertificate')}}>{Lang({id: 'WuZhengShu', default: '无证书'})} </span>
                                            <span className={`CertificateType-option ${item.hasCertificate == 2?'cur':''}`} onClick={(e) => {this.setCertificateType(2,inx,'hasCertificate')}}>{Lang({id: 'WuZhengShuChuHuo', default: '无证书出货'})}</span>
                                        </div>
                                        {
                                            item.hasCertificateList === 1?<div>
                                                <div className='CertificateList'>
                                                    {item.goodsCertificateList && item.goodsCertificateList.map(value => {
                                                        return <span className='CertificateItem'>
                                                            {value.code}
                                                        </span>
                                                    })}
                                                    
                                                </div>
                                            </div>:null
                                        }
                                </FormItem>
                            </FormItem>
                        </Col>
                        {/* <Col offset={1}>
                            {item.hasCertificate==1?
                                <FormItem { ...formItemLayout}
                                          label={''}
                                          name={'certificateCode'}
                                          rules={[{ required:true, message: Lang({id: 'certificateEncoding', default: '证书编码'})}]}>
                                    <Input value={item.certificateCode}
                                           disabled={item.disabled}
                                           defaultValue={item.certificateCode}
                                           onChange={(e)=>this.onChangeField(e,inx,'certificateCode')}
                                           placeholder={Lang({id: 'certificateEncoding', default: '证书编码'})} />
<<<<<<< HEAD
                                </FormItem>:<span className={'timeTips'}>{Lang({id: 'ZuiJinChuLiShiJian', default: '最近处理时间'})}：{moment(item.handleTime).format('YYYY-MM-DD')}</span>}
                        </Col> */}
{/* =======
                                </FormItem>:<span className={'timeTips'}>{Lang({id: 'ZuiJinChuLiShiJian', default: '最近处理时间'})}：{dayjs(item.handleTime).format('YYYY-MM-DD')}</span>}
                        </Col>
>>>>>>> remotes/origin/master */}
                    </Row>
                    <FormItem {...formItemLayout}
                              label={''}
                              name={'remark'}
                              rules={[{ required:item.hasCertificate==0? true:false, message:Lang({id: 'BeiZhu', default: '备注'})}]}>
                                <TextArea
                                    placeholder={Lang({id: 'BeiZhu', default: '备注'})}
                                    onChange={(e)=>this.onChangeField(e,inx,'remark')}
                                    defaultValue={item.remark}
                                    value={item.remark}
                                    disabled={item.disabled} />
                    </FormItem>
                </div>
            </div>
        </div>)
    }
    /**
     * 行编
     *
     * */
    onChangeField(e,inx,field){
        const { target:{value}} = e;
        const {list,isHadEdit} = this.state;
        let newList = [...list];
        newList[inx][field] = value;
        this.setState({
            list:newList,
        })
        if(!isHadEdit)this.setHadEdit(true);
    }
    /**
     * 设置是否编辑过
     **/
    setHadEdit(flag){
        this.setState({
            isHadEdit : flag
        })
    }
    /**
     * 提交按钮
     * */
    handleOK = async() => {
        try {
            const values = await this.formRef.current.validateFields();
            console.log('values',values);
            this.saveDate();
        } catch (errorInfo) {
           console.log('errorInfo',errorInfo)
        }
    };
    saveDate(){
            const {list,eventCode,iId} = this.state;
            this.loading(true);
            let trackItemList = [];
            list.forEach(item=>{
                trackItemList.push({
                    hasCertificate: item.hasCertificate===2?1:item.hasCertificate,
                    isFurnishCertificate:item.hasCertificate === 2?0:(item.hasCertificate===1?1:-1),
                    certificateCode:item.certificateCode,
                    poId:item.poId,
                    poItemId:item.poItemId,
                    remark:item.remark,
                    skuId:item.skuId,
                    trackItemId:item.trackItemId,
                })
            })
            const postData = {
                eventCode:eventCode,
                trackId:iId,
                trackItemList:trackItemList,
            }
            CustomsDeclarationStickerAction.saveCertificateAuditDetail(postData).then(res=>this.handleSaveRes(res.data)).catch(err=>this.handleSaveRes(err))

    }
    handleSaveRes(res){
        this.loading(false);
        const {success,valid,} = res;
        if(success&&valid){
            this.setHadEdit(false);
            message.success(Lang({id: 'CaoZuoChengGong', default: '操作成功'}));
            this.setState({
                isEdit:false
            })
            setTimeout(()=>{
                this.props.history.push('/customsDeclarationSticker/certificateReview')
            },1000);
        }else if(res.message){
            message.warning(res.message);
        } else message.warning(Lang({id:'CaoZuoShiBai',default: "操作失败",}));
    }
    formRef = React.createRef();
    componentDidMount() {
        window.addEventListener('beforeunload', this.listener)
        const { location:{search,pathname} } = this.props;
        const sId = this.getCerId(search,pathname);
        this.getDetail(sId);
    }
    componentWillUnmount(){
        window.removeEventListener('beforeunload', this.listener)
    }

    onRefPageCommon = (ref) => this.onRefPageCommonChild = ref; 
    render(){
        const { loading,item,isEdit,list,isHadEdit,formItemLayout,certDict,iId } = this.state;
        const currPageName = Lang({id: "ZhengShuShenHe",default: "证书审核"});

        let btnList= [
            { 
                btn: Lang({id:'TiJiao',default:'提交'}),
                icon:"ri-check-line color-blue mr_4",
                btnClick:()=>this.handleOK()
            },
        ]
        return (
            <PageCommon onRef={this.onRefPageCommon} className={"transferWrap"} btnList={btnList}>
                <Spin tip='loading' spinning={loading}>
                    <Prompt
                        when={isHadEdit}
                        message={() =>Lang({id:'LiKaiDangQianYeHou，SuoBianJiDeShuJuJiangBuKeHuiFu',default:'离开当前页后，所编辑的数据将不可恢复'})}
                    />
                    {
                        item.poCode?<CommonBreadcrumb list={[
                            { name:currPageName,link:'/customsDeclarationSticker/certificateReview'},{name:item&&item.poCode?item.poCode:''}]}></CommonBreadcrumb>:null
                    }
                    
                    <div className="certificateReviewListStyle">
                        <div className={'content'}>
                            <div className={'title'}>{currPageName}</div>
                            {item.isChinaOrder==1?<div className={"flex-item-ver-center mb_12 color-red2"}>
                                <IconChinaOrderGoods size={20} />
                                <span className={"ml_4 color-red2"}>
                                {Lang({id:'DangQianDingDanKeHuYaoQiuZhongGuoZhiFaTiShi2', default:'当前订单客户要求中国直发，可直接提交'})}
                            </span>
                            </div>:null}
                            <div className={'itemList'}>
                                {/*<Form ref={this.formRef} onFinish={this.handleOK} name="basic" colon={false} >*/}
                                {/*{this.renderList(list,isEdit,formItemLayout,certDict)}*/}
                                {/*</Form>*/}
                                <Form ref={this.formRef} name="dynamic_form_nest_item" onFinish={this.handleOK} autoComplete="off" colon={false} >
                                    {list.map((field,inx) =>{
                                        field['Input_Copy_'+inx] = field.customsCode;
                                        return(  <Form.List name={'trackItemId_'+field.trackItemId} key={inx} initialValue={field}>
                                                {(fields, { add, remove }) => this.renderOne(field,isEdit,formItemLayout,certDict,inx)}
                                            </Form.List>
                                        )  }
                                    )}
                                </Form>
                            </div>
                        </div>
                        {/* {isEdit&&<div className={'footer'}>
                            <div className={'footer-right'}>
                                <span className={'btn btn-red'} onClick={()=>this.handleOK()}>{Lang({id:'TiJiao',default:'提交'})}</span>
                            </div>
                        </div>} */}
                    </div>
                </Spin>
        
            </PageCommon>
        )
    }
}
export default CertificateReviewList;